<template>
    <div class="py-4 space-y-4 text-sm">
        <!-- User stats -->
        <div class="grid grid-cols-4 gap-4">
            <support-stat-box
                v-if="stats.most_assigned_tickets"
                :value="stats.most_assigned_tickets[0] ? stats.most_assigned_tickets[0].tickets_count : 0"
                :subvalue="stats.most_assigned_tickets[0] ? stats.most_assigned_tickets[0].name : ''"
                :label="lang('support::tickets.stats.most_assigned_tickets')"
                :loading="loading.stats"
                :leaderboard="stats.most_assigned_tickets"
                leaderboard-value="tickets_count"
            >
                <template #icon>
                    <icon icon="quill/sort" class="w-5 h-5"></icon>
                </template>
            </support-stat-box>
            <support-stat-box
                v-if="stats.most_closed_tickets"
                :value="stats.most_closed_tickets[0] ? stats.most_closed_tickets[0].actions_count : 0"
                :subvalue="stats.most_closed_tickets[0] ? stats.most_closed_tickets[0].name : ''"
                :label="lang('support::tickets.stats.most_closed_tickets')"
                :loading="loading.stats"
                :leaderboard="stats.most_closed_tickets"
                leaderboard-value="actions_count"
            >
                <template #icon>
                    <icon icon="quill/sign" class="w-5 h-5"></icon>
                </template>
            </support-stat-box>
            <support-stat-box
                v-if="stats.most_assigned_tickets_this_month"
                :value="
                    stats.most_assigned_tickets_this_month[0]
                        ? stats.most_assigned_tickets_this_month[0].tickets_count
                        : 0
                "
                :subvalue="
                    stats.most_assigned_tickets_this_month[0] ? stats.most_assigned_tickets_this_month[0].name : ''
                "
                :label="lang('support::tickets.stats.most_assigned_tickets')"
                :info="lang('support::tickets.stats.this_month')"
                :loading="loading.stats"
                :leaderboard="stats.most_assigned_tickets_this_month"
                leaderboard-value="tickets_count"
            >
                <template #icon>
                    <icon icon="quill/folder" class="w-5 h-5"></icon>
                </template>
            </support-stat-box>
            <support-stat-box
                v-if="stats.most_closed_tickets_this_month"
                :value="
                    stats.most_closed_tickets_this_month[0] ? stats.most_closed_tickets_this_month[0].actions_count : 0
                "
                :subvalue="stats.most_closed_tickets_this_month[0] ? stats.most_closed_tickets_this_month[0].name : ''"
                :label="lang('support::tickets.stats.most_closed_tickets')"
                :info="lang('support::tickets.stats.this_month')"
                :loading="loading.stats"
                :leaderboard="stats.most_closed_tickets_this_month"
                leaderboard-value="actions_count"
            >
                <template #icon>
                    <icon icon="quill/user-happy" class="w-5 h-5"></icon>
                </template>
            </support-stat-box>
        </div>

        <!-- Global stats -->
        <div class="grid grid-cols-4 gap-4">
            <support-stat-box
                :value="stats.open"
                :label="lang('support::tickets.filters.opened')"
                :loading="loading.stats"
            >
                <template #icon>
                    <icon icon="quill/mail" class="w-5 h-5"></icon>
                </template>
            </support-stat-box>
            <support-stat-box
                :value="stats.closed"
                :label="lang('support::tickets.filters.closed')"
                :loading="loading.stats"
            >
                <template #icon>
                    <icon icon="quill/mail-subbed" class="w-5 h-5"></icon>
                </template>
            </support-stat-box>
            <support-stat-box
                :value="stats.unassigned"
                :label="lang('support::tickets.filters.unassigned')"
                :loading="loading.stats"
            >
                <template #icon>
                    <icon icon="quill/folder" class="w-5 h-5"></icon>
                </template>
            </support-stat-box>
            <support-stat-box
                :value="stats.assigned"
                :label="lang('support::tickets.filters.assigned')"
                :loading="loading.stats"
            >
                <template #icon>
                    <icon icon="quill/label" class="w-5 h-5"></icon>
                </template>
            </support-stat-box>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { lang } from '@/lang/composable';
import SupportStatBox from '@src/Support/Pages/Dashboards/Partials/SupportStatBox.vue';

const stats = ref({});

const loading = ref({
    stats: false,
});

const load = async () => {
    loading.value.stats = true;

    axios.get(route('support.frontend.stats.overview')).then(({ data }) => {
        stats.value = data;

        loading.value.stats = false;
    });
};

onMounted(() => {
    load();
});
</script>
